import { useState, useEffect } from 'react';
import { GalleryData, PricingData } from '../types/gallery';

export const useGalleryData = () => {
  const [galleryData, setGalleryData] = useState<GalleryData | null>(null);
  const [pricingData, setPricingData] = useState<PricingData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [galleryResponse, pricingResponse] = await Promise.all([
          fetch('/data/gallery.json'),
          fetch('/data/pricing.json')
        ]);

        if (!galleryResponse.ok || !pricingResponse.ok) {
          throw new Error('Failed to fetch data');
        }

        const gallery = await galleryResponse.json();
        const pricing = await pricingResponse.json();

        setGalleryData(gallery);
        setPricingData(pricing);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Unknown error');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { galleryData, pricingData, loading, error };
};